export function toggleSidebarAction() {
    return function action(dispatch) {
        dispatch({
            type: 'TOGGLE_SIDEBAR'
        });
    };
};